import * as React from 'react';
import styled from 'styled-components';
import { ShippingAddressFormInputs } from '../../../forms/ShippingAddressFormInputs';
import { ShippingContactFormInputs } from '../../../forms/ShippingContactFormInputs';
import { TextArea } from '../../../../../../widgets/FormikInputFieldV2';

const InputContainer = styled.div`
  max-width: 565px;
  margin-top: 20px;
`;

export const ShippingInputs: React.FunctionComponent = () => {
  return (
    <InputContainer>
      <ShippingContactFormInputs />

      <ShippingAddressFormInputs />

      <TextArea name="shippingNotes" label="Shipping Notes" className="mt-1" />
    </InputContainer>
  );
};
